import {TextToolTip} from "components";
import moment from "moment";
import {DeleteActionBtn, EditActionBtn} from "components";
import {allStatusesList, Statuses} from "fragments";
import {Svg} from "assets";

export const vehicleDetails = (item) => {
    return [
        {
            list: [
                {
                    list: [
                        {
                            title: "Make",
                            desc: item?.make,
                        },

                        {
                            title: "VIN",
                            desc: item?.vin,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Model",
                            desc: item?.modelName,
                            width: '25%',
                        },

                        {
                            title: "Unit",
                            desc: item?.unitNumber,
                            width: 'calc(25% - 12px)',
                        },

                        {
                            title: "Type",
                            desc: item?.type,
                            width: '50%',
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Year",
                            desc: moment(item?.year).format("YYYY"),
                        },

                        {
                            title: "Color",
                            desc: item?.color,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "License Plate",
                            desc: item?.license,
                        },

                        {
                            title: "Seats",
                            desc: item?.seats,
                        },
                    ],
                },
            ],
        },
    ];
};

export const vehiclesHead = () => {
    return [
        {title: "Unit", name: 'unitNumber', searchKey: "unitNumber", width: "80px"},
        {title: "Make", name: 'make', searchKey: "make"},
        {title: "Model", name: 'modelName', searchKey: "modelName"},
        {title: "Year", name: 'year', searchKey: "year"},
        {title: "Status", name: 'status',disabled: true, filterList: [{name: "All", id: "All"}, ...allStatusesList], width: 149},
        {title: "Action", custom: false, width: "88px"},
    ];
};

export const vehiclesBody = ({handleDelete, handleEit}) => {
    return [
        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.unitNumber}
                    content={item?.unitNumber}
                />
            ),
        },

        {
            rowText: (item) => <TextToolTip text={item?.make} content={item?.make}/>,
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.modelName} content={item?.modelName}/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.year !== 'Invalid date' ? item?.year : ''}
                    content={item?.year !== 'Invalid date' ? item?.year : ''}
                    dateRow
                    format="YYYY"
                />
            ),
        },

        {
            rowText: (item) => <Statuses status={item?.status}/>,
        },

        {
            rowText: (item) => (
                <div className="flex-all-center" style={{gap: 8}}>
                    <EditActionBtn onClick={() => handleEit(item)}/>
                    <DeleteActionBtn onClick={() => handleDelete(item)}/>
                </div>
            ),
            notClickable: true,
        },
    ];
};

export const emptyState = (addVehicle) => {
    return {
        emptyBtnText: 'Add Vehicle',
        notTitleText: 'No vehicles added yet',
        notDescText: 'Add your first vehicle to start tracking availability and assigning it to trips.',
        EmptySvg: Svg.EmptyVehicle,
        clickToEmptyAddButton: () => addVehicle(),
    }
}